<vex-base-layout>
  <vex-progress-bar></vex-progress-bar>

  <mat-sidenav-container class="vex-layout-sidenav-container">
    <mat-sidenav (closedStart)="onSidenavClosed()" [disableClose]="!!(sidenavDisableClose$ | async)"
      [fixedInViewport]="!!(sidenavFixedInViewport$ | async)" [mode]="(sidenavMode$ | async) ?? 'side'"
      [opened]="!!(sidenavOpen$ | async)">
      <vex-sidenav [collapsed]="!!(sidenavCollapsed$ | async)"></vex-sidenav>
    </mat-sidenav>

    <!-- Abel 30/10/24: Añado task panel -->
    <mat-sidenav (closedStart)="onTaskPanelClosed()"
      [opened]="!!(taskPanelOpen$ | async)" class="vex-layout-quickpanel"
      [class.task-panel]="taskPanelOpen$ | async" mode="over" position="end">
      @if (taskPanelOpen$ | async) {
      <vex-task-panel></vex-task-panel>
      }
    </mat-sidenav>

    <mat-sidenav-content class="vex-layout-sidenav-content">
      <vex-toolbar [class.hidden]="isDesktop$ | async" class="vex-toolbar"></vex-toolbar>

      <main class="vex-layout-content">
        <router-outlet></router-outlet>
      </main>
    </mat-sidenav-content>
  </mat-sidenav-container>

  <!-- CONFIGPANEL -->
  <vex-sidebar #configpanel [invisibleBackdrop]="true" [opened]="!!(configPanelOpen$ | async)" position="right">
    <vex-config-panel></vex-config-panel>
  </vex-sidebar>
  <!-- END CONFIGPANEL -->
</vex-base-layout>